import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button, Modal, Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ButtonSuccess from '../../../../components/Button';

import '../../../../layout/Modal.scss';
import { withdrawResetTwoFaAdmin } from '../../../../redux/actions/adminPanel/adminFeeWithdraw';
import { identity } from '../../../../utils/getIdentity';
import ResendPhone2FA from '../../../../ResendPhone2FA';
import ResendEmail2FA from '../../../../components/ResendEmail2FA';
import { ReactComponent as SuccessIcon } from '../../../../img/default-svg/success.svg';

const WithdrawTwoFaConfirm = ({
  isVisible,
  setIsVisible,
  action,
  isAppTwoFa,
  isEmailTwoFa,
  isPhoneTwoFa,
  clearWithdrawState,
  fetching,
  walletId,
  body,
  withdrawResetTwoFaAdmin,
}) => {
  const { t } = useTranslation();

  const [twoFactorCode, setTwoFactorCode] = useState('');
  const [emailTwoFactorCode, setEmailTwoFactorCode] = useState('');
  const [verifyCode, setVerifyCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const [withdrawConfirmForm] = Form.useForm();

  const handleSubmit = async () => {
    await withdrawConfirmForm.validateFields();
    setIsLoading(true);
    const response = await action(walletId, {
      ...body,
      twoFactorToken: twoFactorCode || undefined,
      emailOtp: emailTwoFactorCode || undefined,
      verifyCode: verifyCode || undefined,
    });

    if (response && response.data.id) {
      setShowSuccessModal(true);
      // clearWithdrawState();
      // setIsVisible(false);
    }

    setIsLoading(false);
  };

  const handleCancel = e => {
    setIsVisible(false);
    withdrawConfirmForm.resetFields();
    withdrawResetTwoFaAdmin({});
    setTwoFactorCode();
    setEmailTwoFactorCode();
    setVerifyCode();
  };

  return (
    <React.Fragment>
      <Modal
        width={534}
        title={showSuccessModal ? '' : 'Enter 2FA'}
        visible={isVisible}
        onOk={handleSubmit}
        onCancel={handleCancel}
        footer={null}
        className={`modal modal-${identity}`}
        closable={showSuccessModal ? false : true}
        maskClosable={showSuccessModal ? false : true}
      >
        {showSuccessModal ? (
          <>
            <div className="withdraw-confirm-success__modal-wrap">
              <>
                <SuccessIcon />
                <span className="withdraw-confirm-success_modal-text withdraw-confirm-success__modal-text-success">
                  {t('multisendWithdraw.success')}
                </span>
                <span className="withdraw-confirm-success__modal-subtext">
                  {t('multisendWithdraw.theTransactionHasBeenSuccessfullyProcessed')}
                </span>
                <div className="withdraw-confirm-success__modal-buttons">
                  <Link to="/admin/transactions">
                    <ButtonSuccess
                      onClick={() => {
                        clearWithdrawState();
                        setIsVisible(false);
                      }}
                    >
                      {t('multisendWithdraw.goToTransactions')}
                    </ButtonSuccess>
                  </Link>
                </div>
              </>
            </div>
          </>
        ) : (
          <>
            <div className="withdraw-twofa-confirm">
              <Form
                form={withdrawConfirmForm}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                name="basic"
                initialValues={{ remember: true }}
                className="modal-form"
              >
                {isPhoneTwoFa && !isEmailTwoFa && !isAppTwoFa && (
                  <>
                    <Form.Item
                      label={t('auth.сodeFromSms')}
                      name="verifyCode"
                      className="modal-form__label"
                      rules={[{ required: true, message: t('validation.phoneTwoFaRequired') }]}
                    >
                      <Input
                        placeholder={t('auth.сodeFromSms')}
                        className="modal-form__input"
                        maxLength="6"
                        onChange={e => setVerifyCode(e.target.value)}
                      />
                    </Form.Item>
                    <ResendPhone2FA />
                  </>
                )}
                {isEmailTwoFa && !isAppTwoFa && (
                  <>
                    <Form.Item
                      label={t('auth.keyFromEmail')}
                      name="emailCode"
                      className="modal-form__label"
                      rules={[{ required: true, message: t('validation.emailTwoFaRequired') }]}
                    >
                      <Input
                        placeholder={t('auth.keyFromEmail')}
                        className="modal-form__input"
                        maxLength="6"
                        onChange={e => setEmailTwoFactorCode(e.target.value)}
                      />
                    </Form.Item>
                    <ResendEmail2FA />
                  </>
                )}
                {isAppTwoFa && (
                  <Form.Item
                    label={t('auth.keyFromGA')}
                    name="authCode"
                    className="modal-form__label"
                    rules={[{ required: true, message: t('validation.twoFaRequired') }]}
                  >
                    <Input
                      placeholder={t('auth.keyFromGA')}
                      className="modal-form__input"
                      maxLength="6"
                      onChange={e => setTwoFactorCode(e.target.value)}
                    />
                  </Form.Item>
                )}
              </Form>
              <Row className="modal__buttons-wrapper">
                <Col span="12">
                  <Button
                    loading={isLoading || fetching}
                    type="primary"
                    className={`modal__button modal__button-create modal__button modal__button-create-${identity} modal__button-create=${identity}`}
                    onClick={handleSubmit}
                  >
                    {t('admin.confirm')}
                  </Button>
                </Col>
                <Col span="12">
                  <Button type="secondary" className="modal__button modal__button-cancel" onClick={handleCancel}>
                    {t('admin.cancel')}
                  </Button>
                </Col>
              </Row>
            </div>
          </>
        )}
      </Modal>
    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  isAppTwoFa: state.adminFeeWithdraw.isAppTwoFa,
  isEmailTwoFa: state.adminFeeWithdraw.isEmailTwoFa,
  isPhoneTwoFa: state.adminFeeWithdraw.isPhoneTwoFa,
});

const mapDispatchToProps = dispatch => ({
  withdrawResetTwoFaAdmin: () => dispatch(withdrawResetTwoFaAdmin()),
});

export default connect(mapStateToProps, mapDispatchToProps)(WithdrawTwoFaConfirm);
